import { UserInfo } from "src/app/core/models/userInfo";

export function checkNumber(value: number | string, defaultValue = 0): number {
    return isNaN(Number(value)) ? defaultValue : Number(value);
}

export function getUserBrandName(user: UserInfo): string {
    if (user.isBMW) {
        return 'BMW';
    } else if (user.isMINI) {
        return 'MINI';
    } else if (user.isROLLSROYCE) {
        return 'ROLLSROYCE';
    } else {
        return '';
    }
}

export function cloneList(list: any[]) {
    const newList = []
    list.forEach(element => {
        newList.push({ ...element });
    });
    return newList;
}

export function is3rdPartyHost() {
    const hostname = document.location.hostname

    return hostname.includes('techinfo') && (hostname.endsWith('.bmwgroup.com') || hostname.endsWith('.aws.bmw.cloud'))
        || hostname === 'tis.com'
        || hostname.endsWith('.tis.com');
}

export function isExternalThirdPartyHost() {
    const hostname = document.location.hostname

    return hostname.includes('techinfo') && hostname.endsWith('.bmwgroup.com')
        || hostname === 'tis.com'
        || hostname.endsWith('.tis.com');
}

export function onlyNumbers(value: string): string {
    if (value === null || value === undefined) {
        return '';
    }
    return value.replace(/\D+/g, '');
}